// Session-Helpers — Auswertung der Session-Expiry für Auto-Refresh.
// V1: inline in useAuth.js. V3: separate Pure-Function für Tests.

import type { AuthSession } from '@/types/auth';

/**
 * V1-Konstante: Refresh-Fenster vor Ablauf. Wenn Token in <300s abläuft
 * wird vorab refreshed.
 */
export const REFRESH_WINDOW_SECONDS = 300;

/**
 * Prüft ob das Token bereits abgelaufen oder kurz vor Ablauf ist und somit
 * ein Refresh nötig ist. `now` defaultet auf jetzt, kann aber für Tests
 * fixiert werden.
 */
export function isSessionExpiringSoon(session: AuthSession | null, now = Date.now()): boolean {
  if (!session?.expires_at) return false;
  const nowSeconds = Math.floor(now / 1000);
  return nowSeconds >= session.expires_at - REFRESH_WINDOW_SECONDS;
}

/**
 * Prüft ob das Token endgültig abgelaufen ist (kein Refresh-Fenster).
 */
export function isSessionExpired(session: AuthSession | null, now = Date.now()): boolean {
  if (!session?.expires_at) return false;
  const nowSeconds = Math.floor(now / 1000);
  return nowSeconds >= session.expires_at;
}

/**
 * Extrahiert den Nickname aus der Email (Default für nicht-gesetzten Profil-Nickname).
 * V1-Pattern: `email.split('@')[0]`.
 */
export function defaultNicknameFromEmail(email: string): string {
  const at = email.indexOf('@');
  return at > 0 ? email.slice(0, at) : email;
}
